import React, { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import Note from "./Note";
import CreateArea from "./CreateArea";

function App() {
  //Create an empty notes array with state that can be accessed with the setNotes function
  const [notes, setNotes] = useState([]);

  //Combines the setNotes function with an anonymous function, returns the span of the original array with the new note
  function addNote(note) {
    setNotes((prevNotes) => {
      return [...prevNotes, note];
    });
  }

  //Uses the setNotes function to filter the original array, returing all notes except the one with the requested id
  function deleteNote(id) {
    setNotes((prevNotes) => {
      return prevNotes.filter((note, index) => {
        return index !== id;
      });
    });
  }

  return (
    <div>
      <Header />
      <CreateArea onAdd={addNote}/>
      {/* Maps the notes array to note elements and providing a unique index to each note */}
      {notes.map((note, index) => (
          <Note key={index} id={index} title={note.title} content={note.content} onDelete={deleteNote} />
        ))}
      <Footer />
    </div>
  )
}

export default App;
